/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Create_DescriptionInputs */

const en_settings_tickets_create_description = /** @type {(inputs: Settings_Tickets_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your issue and we'll respond as soon as possible`)
};

const zh_settings_tickets_create_description = /** @type {(inputs: Settings_Tickets_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述你遇到的问题,我们会尽快回复`)
};

/**
* | output |
* | --- |
* | "Describe your issue and we'll respond as soon as possible" |
*
* @param {Settings_Tickets_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_create_description = /** @type {((inputs?: Settings_Tickets_Create_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Create_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_create_description(inputs)
	return zh_settings_tickets_create_description(inputs)
});
export { settings_tickets_create_description as "settings.tickets.create_description" }